import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Paper, Typography } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/styles";
import Fade from "@material-ui/core/Fade";
import Slide from "@material-ui/core/Slide";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import MuiTableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
  resetRedirection,
  resetRedirectionParams
} from "../../actions/redirect";
import { resetCardData } from "../../actions/card";
import { calculateAmount } from "../../utils/SurchargeUtils";
import { FormatAmount } from "../../utils/Formatter";
import { clipCardNumber, mastBin } from "../../utils/BinUtils";
import {
  fetchOtpParams,
  regenerateOtp,
  resetOtpError,
  resetOtpParams,
  resetOtpRedirection
} from "../../actions/otp";

const TableCell = withStyles({
  root: {
    borderBottom: "none"
  }
})(MuiTableCell);

const useStyles = makeStyles(() => {
  return {
    otpOverlay: {
      background: "#00000080",
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 100
    },
    otpContainer: {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 101,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: "30px",
      maxWidth: "390px"
    },
    helperText: {
      marginLeft: 0,
      textOverflow: "ellipsis",
      width: "155px",
      overflow: "hidden",
      whiteSpace: "unset",
      padding: 0,
      background: "#f5f3f300",
      fontSize: "0.75rem"
    },
    MessageStyle: {
      textAlign: "center",
      fontSize: "12px"
    }
  };
});

const RESEND_OTP_TIME = 29;
const d = new Date().toLocaleString();

export const OtpPage = ({
  charge,
  cardData,
  dispatch,
  otpRedirecting,
  otpError,
  redirectParams,
  history
}) => {
  const classes = useStyles();
  const location = useLocation();
  const [checked, setChecked] = useState(true);
  const [otp, setOtp] = useState("");
  const [counter, setCounter] = useState(RESEND_OTP_TIME);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [resendOtp, setResendOtp] = useState(false);
  const [ipAddress, setIpAddress] = useState("14.143.131.62");
  const [dateTime] = useState(d);

  const { due, paymentFamilies, currency, shopName } = charge;

  const totalAmount = calculateAmount(
    due,
    location.pathname,
    paymentFamilies.surcharges
  );

  const formatedTotalAmount = FormatAmount(totalAmount, currency);

  const message = `Otp Length Should  be  atleast 4 character`;

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setInterval(() => setCounter(counter - 1), 1000);
    } else if (counter === 0) {
      setResendOtp(true);
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [counter]);
  useEffect(() => {
    fetch("https://api64.ipify.org/?format=json")
      .then(response => response.json())
      .then(data => {
        if (
          !(data.ip === "Not found") &&
          !(data.ip === undefined) &&
          !(data.ip.trim() === "")
        ) {
          setIpAddress(data.ip);
        }
      });
  }, [ipAddress]);
  const submitOtpForm = () => {
    if (!otp) {
      setError(true);
      setErrorMsg("Enter OTP");
    } else if (otp.length < 4) {
      setError(true);
      setErrorMsg(message);
    } else {
      setError(false);
      setErrorMsg("");

      const form = {
        otp,
        ipAddress
      };
      dispatch(
        fetchOtpParams(
          redirectParams.transactionUuid,
          form,
          charge.uuid,
          history
        )
      );
    }
  };

  const otpChangeHandler = event => {
    const otpNumber = event.target.value;
    if (!/^\d*$/.test(otpNumber)) {
      return;
    }
    setOtp(otpNumber);
    setErrorMsg("");
    setError(false);
  };

  const resendOtpHandler = () => {
    setResendOtp(false);
    setCounter(RESEND_OTP_TIME);
    dispatch(regenerateOtp(redirectParams.transactionUuid));
  };

  const otpCloseHandler = () => {
    dispatch(resetRedirectionParams());
    dispatch(resetRedirection());
    dispatch(resetCardData());

    dispatch(resetOtpParams());
    dispatch(resetOtpRedirection());
    dispatch(resetOtpError());
  };

  const group = number => {
    const numbersArray = [];
    for (let i = 0; i < number.length; i += 4) {
      numbersArray.push(number.substr(i, 4));
    }
    return numbersArray.join(" ");
  };

  const groupSavedCard = maskedPan => {
    const defaultCardSize = 16;
    const cardNumber = clipCardNumber(maskedPan);
    const cardNumberSize = cardNumber.length;
    const sizeNeeded = defaultCardSize - cardNumberSize;
    let cardNumberArr = "";
    for (let i = 0; i < sizeNeeded; i += 1) {
      cardNumberArr += "X";
    }
    if (cardNumberSize > 4) {
      cardNumberArr += mastBin(cardNumber);
    } else {
      cardNumberArr += maskedPan;
    }
    return group(cardNumberArr);
  };

  return (
    <>
      <Fade in={checked}>
        <div className={classes.otpOverlay} />
      </Fade>
      <div className={classes.otpContainer}>
        <Slide
          direction="down"
          in={checked}
          mountOnEnter
          unmountOnExit
          onExited={otpCloseHandler}
        >
          <Paper className={classes.paper} elevation={3}>
            <Table size="small" className={classes.tableText}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    <Typography
                      variant="caption"
                      style={{
                        fontSize: "12px",
                        display: "inline-block",
                        lineHeight: 1.5
                      }}
                    >
                      Please enter your One Time Password (OTP) sent to your
                      registered Mobile Number
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Card No:</TableCell>
                  {cardData.type === "savedcard" ? (
                    <TableCell>{groupSavedCard(cardData.maskedPan)}</TableCell>
                  ) : (
                    <TableCell>
                      {group(mastBin(clipCardNumber(cardData.cardNumber)))}
                    </TableCell>
                  )}
                </TableRow>
                <TableRow>
                  <TableCell>Merchant:</TableCell>
                  <TableCell>{shopName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Amount:</TableCell>
                  <TableCell>{formatedTotalAmount}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Enter OTP:</TableCell>
                  <TableCell>
                    <TextField
                      error={error || !!otpError}
                      label="OTP"
                      id="outlined-otp"
                      variant="outlined"
                      size="small"
                      type="password"
                      minLength="4"
                      helperText={errorMsg || (otpError || "")}
                      style={{ width: 100 }}
                      value={otp}
                      inputProps={{
                        minLength: 4,
                        maxLength: 10,
                        regex: /^\d*$/
                      }}
                      onChange={otpChangeHandler}
                      FormHelperTextProps={{
                        className: classes.helperText
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="center"
                    style={{
                      fontWeight: 400,
                      fontSize: "12px",
                      padding: resendOtp ? 0 : "6px 24px 6px 16px"
                    }}
                  >
                    {resendOtp ? (
                      <Button
                        color="primary"
                        size="small"
                        onClick={resendOtpHandler}
                        disabled={otpRedirecting}
                      >
                        Resend OTP
                      </Button>
                    ) : (
                      <span>
                        Resend OTP in&nbsp;
                        <span style={{ fontWeight: 600 }}>
                          {counter}
                          &nbsp;sec
                        </span>
                      </span>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.MessageStyle} colSpan={2}>
                    <b>Please Do Not Refresh</b>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10
              }}
            >
              <Button
                size="small"
                variant="contained"
                color="primary"
                style={{ marginRight: 15 }}
                disableElevation
                onClick={submitOtpForm}
                disabled={otpRedirecting}
              >
                {otpRedirecting ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  `Submit`
                )}
              </Button>
              <Button
                size="small"
                variant="contained"
                style={{ marginLeft: 15 }}
                disableElevation
                onClick={() => setChecked(false)}
                disabled={otpRedirecting}
              >
                Cancel
              </Button>
            </div>
            <div>
              <Typography
                style={{
                  align: "center",
                  fontSize: "10px",
                  display: "inline-block",
                  lineHeight: 1.25
                }}
              >
                <br />
                <br />
                Your transaction is processed through a secure 128 bit https
                internet connection based on secure layer technology. security
                security purpose your IP address &nbsp;
                {ipAddress}
                &nbsp; and access time &nbsp;
                {dateTime}
              </Typography>
            </div>
          </Paper>
        </Slide>
      </div>
    </>
  );
};

OtpPage.propTypes = {
  charge: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    due: PropTypes.number.isRequired,
    shopName: PropTypes.string.isRequired,
    paymentFamilies: PropTypes.shape({
      surcharges: PropTypes.arrayOf(PropTypes.shape())
    }).isRequired
  }).isRequired,
  cardData: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  redirectParams: PropTypes.shape({
    transactionUuid: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape().isRequired,
  otpRedirecting: PropTypes.bool,
  otpError: PropTypes.string
};

OtpPage.defaultProps = {
  otpRedirecting: undefined,
  otpError: undefined
};

function mapStateToProps({
  chargeReducer,
  cardReducer,
  otpReducer,
  redirectionReducer
}) {
  return {
    ...chargeReducer,
    ...cardReducer,
    ...otpReducer,
    ...redirectionReducer
  };
}

export default connect(mapStateToProps)(OtpPage);
